import React from 'react'
import ReactPlayer from 'react-player'

const CoursePlayer = ({course}) => {
  return (
    <div className="w-full">
      <ReactPlayer 
        url={course}
        controls={true}
        playIcon={<button>Play</button>}
        width="100%"
        height="auto"
        style={{ aspectRatio: '16/9' }}
      />
    </div>
  )
}

export default CoursePlayer